import useFormatDate from '@/src/hooks/date/useFormatDate'
import { FlightSegment } from '@/src/types/itinerary'
import { checkNextDayArrival } from '@/src/utils/itinerary/checkNextDayArrival'
import { useTranslations } from 'next-intl'
import SegmentHeader from './segmentHeader'

interface SegmentHeaderWrapperProps {
    fromCity: string
    toCity: string
    departureDate: string
    flightIndex: number
    segments: FlightSegment[]
    isConfirmationPage?: boolean
    isPnrLoading?: boolean
}

const SegmentHeaderWrapper = ({
    fromCity,
    toCity,
    departureDate,
    flightIndex,
    segments,
    isConfirmationPage = false,
    isPnrLoading = false
}: SegmentHeaderWrapperProps) => {
    const { formatDate } = useFormatDate()
    const t = useTranslations('common')
    const route = t('segmentHeading', { fromCity, toCity })
    const isNextDayArrival = checkNextDayArrival(segments, formatDate)
    const arrivesNextDayCallout = isNextDayArrival ? t('arrivesNextDay') : ''
    const pnrNumber = segments?.[0]?.pnrNumber || ''
    const pnr = pnrNumber ? t('pnr', { pnrNumber }) : ''

    return (
        <SegmentHeader
            route={route}
            departureDate={formatDate(departureDate, 'ddd, DD MMM YYYY')}
            flightIndex={flightIndex}
            arrivesNextDayCallout={arrivesNextDayCallout}
            isConfirmationPage={isConfirmationPage}
            pnr={pnr}
            isPnrLoading={isPnrLoading}
        />
    )
}

export default SegmentHeaderWrapper
